import stbAPIGateway from '../../../../services/stbAPIGateway';

// eslint-disable-next-line import/prefer-default-export
export const patchClientExcursionManagement = async (
  { rootGetters },
  { clientSid, clientExcursionManagement }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.patchClientExcursionManagementBySid(
    clientSid,
    clientExcursionManagement
  );
  return response;
};
